(function () {
  function toggleModeAutre() {
    var checkboxes = document.querySelectorAll(
      'input[type="checkbox"][name^="mode"]'
    );
    var wrapper = document.getElementById('mode-autre-wrapper')
      || document.querySelector('.mode-autre-wrapper');
    var autreInput = document.querySelector('input[name^="mode-autre"]');
    if (!wrapper || !checkboxes.length) return;

    var isAutreChecked = false;
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked && /autre/i.test(checkboxes[i].value)) {
        isAutreChecked = true;
        break;
      }
    }

    wrapper.style.display = isAutreChecked ? 'block' : 'none';
    wrapper.classList.toggle('is-visible', isAutreChecked);
    if (autreInput) {
      autreInput.required = isAutreChecked;
      if (!isAutreChecked) autreInput.value = '';
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.type === 'checkbox' && t.name && t.name.indexOf('mode') === 0) {
      toggleModeAutre();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', toggleModeAutre);
  } else {
    toggleModeAutre();
  }
  window.addEventListener('load', toggleModeAutre);
})();



// WEBPACK FOOTER //
// ./scripts/mode-autre.js